import React, { useEffect, useState } from 'react';
import { useNavigate, useRoutes, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import routes from './routes';
import { ConfigProvider, message } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import emptyListData from './assets/img/common/emptyListData.png';
import { RootState } from './redux/store';
import { actionSendHttpRequest } from './redux/action';
import { LoginState } from './redux/type';
import { getPermissionById, getPermissionTabs, isEmpty } from './utils';
import { HttpStatusCode } from './fetch/core/constant';
import { api } from './fetch/bussiness/api';
import { connect } from 'react-redux';
import '@/assets/css/index.scss';
import { sendGlobalEvent } from './utils/emit';
import { CockpitMode, CockpitType } from '@/utils/constant';
import ActionType from './redux/actionType';
import '@jd/x-coreui/lib/index.css';
import { Method } from './fetch/core/util';
import { CommonEnumKey } from './utils/enum';

const shouldComponentUpdate = (prevProps: RootState, nextProps: RootState) => {
  // true不做更新，false更新
  return true;
};
const App = () => {
  const CockpitModeList = [
    CockpitMode.LISTENING_MODE,
    CockpitMode.WATCH_CAR_MODE,
    CockpitMode.PATROL_MODE,
  ];
  const login = useSelector((state: RootState) => state.login);
  const navigator = useNavigate();
  const routing = useRoutes(routes);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (
      login.state === LoginState.LOGINED &&
      location.pathname !== '/app/403'
    ) {
      const allEnumValues = Object.values(CommonEnumKey) || [];
      const requestData: HTTPFetchActionParams = {
        path: '/monitor/web/enum/get_enum_list_map',
        method: 'POST',
        body: {
          keyList: allEnumValues,
        },
        actionType: ActionType.GET_ENUM_LIST_MAP,
      };
      dispatch(actionSendHttpRequest(requestData));
    }
  }, [login.state]);

  /**
   * passport接口调用成功之后再请求info接口
   */
  useEffect(() => {
    if (login.getPassportTokenSuccess) {
      setTimeout(() => {
        getCurrentUserInfoData((res: any) => {
          if (!isEmpty(res.data.resourceList)) {
            const pagePermission = getPermissionTabs(res.data.resourceList);
            if (isEmpty(pagePermission)) {
              message.warning('您当前无访问权限，请联系管理员添加权限。');
              if (!location.pathname.includes('login')) {
                navigator('/login');
              }
            } else {
              // 处在登录页时要自动跳到有权限的页面
              if (location.pathname.includes('login')) {
                navigator(pagePermission[0].navigator);
              }
            }
          } else {
            message.warning('您当前无访问权限，请联系管理员添加权限。');
            if (!location.pathname.includes('login')) {
              navigator('/login');
            }
          }
        });
      }, 1000);
    }
  }, [login.getPassportTokenSuccess]);

  useEffect(() => {
    if (getPermissionById('spv_cockpitMode')) {
      document.addEventListener('visibilitychange', (data) => {
        if (document.visibilityState === 'visible') {
          getCockpitStatusInfo();
        }
      });
    }
    return () => {
      document.removeEventListener('visibilitychange', () => {});
    };
  }, []);

  useEffect(() => {
    if (login.user) {
      return;
    }
    getCurrentUserInfoData();
  }, [location.pathname]);
  const handlePassportValidate = () => {
    const loginParams: HTTPFetchActionParams = {
      absoluteURL: `${window.location.protocol}//${process.env.JDX_APP_FETCH_DATA_DOMAIN}${api.passportLogin}`,
      method: 'GET',
      urlParams: {
        appCode: 'rover-auto-monitor-ui',
      },
      actionType: 'GET_PASSPORT_TOKEN',
      nextActionFunc: (resp: any) => {
        if (
          resp.code !== HttpStatusCode.Success &&
          localStorage.getItem('logout') !== 'logout'
        ) {
          message.error(resp.message);
        }
        localStorage.setItem('reload', 'false');
        localStorage.removeItem('logout');
      },
    };
    dispatch(actionSendHttpRequest(loginParams));
  };
  const getCurrentUserInfoData = (cb?: AnyFunc) => {
    // 用token登录，获取登录用户信息和权限
    const loginData: HTTPFetchActionParams = {
      method: 'POST',
      path: api.getUserInfo,
      body: {
        appCode: 'rover-auto-monitor-ui',
      },
      actionType: 'USER_INFO',
      nextActionFunc: (resp: any) => {
        if (resp?.code != HttpStatusCode.Success) {
          message.error('登录过期，请重新登录');
          navigator('/login');
        } else {
          handlePassportValidate();
          cb && cb(resp);
          const hasVehiclePermission =
            resp?.data?.resourceList?.findIndex(
              (item: any) => item.code === 'spv_realtime'
            ) > -1;
          const hasPDAPermission =
            resp?.data?.resourceList?.findIndex(
              (item: any) => item.code === 'spv_pda_page'
            ) > -1;
          if (
            !hasVehiclePermission &&
            !hasPDAPermission &&
            location.pathname !== '/app/403'
          ) {
            navigator('/app/403');
            return;
          }
          if (!hasVehiclePermission && hasPDAPermission) {
            // 没有无人车权限，只有pda权限
            window.location.href = '/pda';
            return;
          }
          sendGlobalEvent('CREATE_WS_CLIENT', {
            userName: resp?.data?.userName,
          });
          if (
            resp?.data?.resourceList?.findIndex(
              (item: any) => item.code === 'spv_cockpitMode'
            ) > -1
          ) {
            getCockpitStatusInfo();
          }
        }
      },
    };
    dispatch(actionSendHttpRequest(loginData));
  };

  const customizeRenderEmpty = () => (
    <div
      style={{
        textAlign: 'center',
        fontSize: '14px',
        color: 'rgba(255,255,255,0.4)',
      }}
    >
      <img src={emptyListData} style={{ maxWidth: '64px' }}></img>
      <p>暂无数据</p>
    </div>
  );

  const getCockpitStatusInfo = () => {
    const payload = {
      method: Method.POST,
      path: '/monitor/web/user/getCockpitStatus',
      actionType: ActionType.CHANGE_COCKPIT_MODE_STATUS,
      nextActionFunc: (res: any) => {
        if (
          res.code === HttpStatusCode.Success &&
          res.data?.cockpitTeamNumber
        ) {
          getMqttToken(res.data);
        }
      },
    };
    dispatch(actionSendHttpRequest(payload));
  };

  const getMqttToken = (cockpitInfo: any) => {
    const payload = {
      method: 'POST',
      path: '/authentication/getMqttLoginToken',
      actionType: ActionType.GET_MQTT_TOKEN,
      nextActionFunc: (res: any) => {
        if (res.code === HttpStatusCode.Success) {
          if (cockpitInfo?.cockpitType === CockpitType.COCKPIT_SEAT) {
            return;
          }
          if (
            cockpitInfo?.cockpitType === CockpitType.MONITOR_SEAT &&
            CockpitModeList.includes(cockpitInfo?.cockpitMode)
          ) {
            // 创建mqtt链接
            res.data &&
              sendGlobalEvent('CREATE_MQTT_CLIENT', {
                token: res.data?.accessToken,
                needIssueInfo: true,
              });
            // 如果座席模式是巡查模式，跳到巡查页面
            if (cockpitInfo.cockpitMode === CockpitMode.PATROL_MODE) {
              navigator('/app/patrolMode');
            }
            // 如果当前在选择座席页面，且模式是听单或盯车，跳到多车页
            if (
              location.pathname === '/app/chooseCockpit' &&
              (cockpitInfo.cockpitMode === CockpitMode.LISTENING_MODE ||
                cockpitInfo.cockpitMode === CockpitMode.WATCH_CAR_MODE)
            ) {
              navigator('/app/realtime');
            }
            // 如果当前在巡查页面，但不是巡查模式，跳到多车页
            if (
              location.pathname === '/app/patrolMode' &&
              cockpitInfo.cockpitMode !== CockpitMode.PATROL_MODE
            ) {
              navigator('/app/realtime');
            }
          } else {
            sendGlobalEvent('CLOSE_MQTT_CLIENT');
          }
        }
      },
    };
    dispatch(actionSendHttpRequest(payload));
  };
  return (
    <ConfigProvider
      renderEmpty={customizeRenderEmpty}
      locale={zhCN}
      theme={{
        components: {
          Message: {
            contentBg: '#162E38',
          },
          Table: {
            headerSplitColor: '#2e334d',
          },
        },
      }}
    >
      {routing}
    </ConfigProvider>
  );
};

const mapPropsToState = (state: RootState) => ({ login: state.login });
export default connect(mapPropsToState)(React.memo(App, shouldComponentUpdate));
